export default __webpack_public_path__ + "static/media/023-magnet.36b95ddc.svg";